<template>
  <div class="checks">
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="filterNormal"
      title="FILTRAR"
    >
      <div class="row">
        <div v-if="$store.state.online" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Data</h6>
          <input type="date" v-model="date" class="form-control" />
        </div>
        <div v-if="$store.state.online" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="status" class="form-control">
            <option value="ATRASADO">ATRASADOS</option>
            <option value="CHECADO">CHECADOS</option>
            <option value="PENDENTE">PENDENTES</option>
            <option value="TODOS">TODOS</option>
          </select>
        </div>
        <div v-if="accessed_offline" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="date" class="form-control">
            <option
              v-for="advanceDate of advanceDates"
              :key="advanceDate"
              :value="advanceDate"
            >
              {{ String(advanceDate).split("-").reverse().join("/") }}
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
          <v-btn
            class="btn-modern btn-modern-delete m-1"
            @click="$bvModal.hide('filterNormal')"
            >CANCELAR</v-btn
          >
          <v-btn
            class="btn-modern btn-modern-save float-right"
            :disabled="loading"
            @click="handleFilter"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div></b-modal
    >
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-12">
        <h1 class="title-pages mb-1 check-text-center">PRESCRIÇÃO</h1>
        <h6
          v-if="$store.state.online"
          class="mb-0 upper-text worksansr check-text-center"
        >
          FILTRANDO CUIDADOS:
          <strong class="color-blue">
            {{ handleTextStatus(status) }}
          </strong>
        </h6>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-4 col-sm-3 col-12 d-flex justify-content-end align-items-center"
      >
        <v-btn
          @click="$bvModal.show('filterNormal')"
          class="btn-modern btn-modern-info"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR</v-btn
        >
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="text-center p-5 v-clean" v-if="!exist">
        <h6 class="worksansr upper-text">Sem resultados!</h6>
      </div>
      <div
        v-for="(check, key) in checks"
        :key="key"
        class="col-md-12 pb-0 pt-0 mb-4"
        v-show="check.items.length > 0"
      >
        <div class="row checks-care-times">
          <div class="col-md-12 checks-care-times-header pt-0 pb-0 mb-1">
            <div class="row">
              <div
                class="col-md-12 d-flex check-justifique-left align-items-center"
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-capsules color-blue mr-2 text-twenty"></i>
                  <h6 class="m-0 check-text-center mr-2">CUIDADOS</h6>
                  <span class="mr-2">|</span>
                  <h6
                    class="m-0 worksansr check-text-center"
                    v-if="check.items.length > 0"
                  >
                    <span v-if="check.time == 'null'">
                      EVENTUAL
                      {{ String(dateLabel).split("-").reverse().join("/") }}
                    </span>
                    <span v-else>
                      HORÁRIO {{ String(check.time).substr(0, 5) }} -
                      {{ String(dateLabel).split("-").reverse().join("/") }}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-12 pb-0 pt-0 b-sidebar-body"
            v-for="(group_prescription_cares, key) in check.items"
            :key="key"
          >
            <div class="row checks-care-time-cares">
              <div
                class="col-md-12 pb-0 pt-1"
                v-for="(
                  group_prescription_care, key
                ) in group_prescription_cares"
                :key="key"
              >
                <div :class="['row']">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div
                      class="form-check d-flex flex-column justify-content-center"
                    >
                      <div class="check-text-center">
                        <h6 class="check-text-center">
                          <DataCare
                            :group_prescription_care="group_prescription_care"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-if="
                        group_prescription_care.prescription_care.frequency !=
                        'EVENTUAL'
                      "
                    >
                      <div
                        v-if="group_prescription_care.care_check.note"
                        class="p-2 bg-light mb-2"
                      >
                        <strong>Não foi realizado pelo motivo:</strong>
                        {{ group_prescription_care.care_check.note }}
                      </div>
                      <div v-if="group_prescription_care.care_check.photo">
                        <img
                          :src="group_prescription_care.care_check.photo"
                          width="300px"
                          height="300px"
                        />
                      </div>
                      <h6
                        class="legends worksansr m-0"
                        v-if="
                          group_prescription_care.care_check.id &&
                          group_prescription_care.care_check.status == 'CHECADO'
                        "
                      >
                        <strong class="upper-text">Checado por:</strong>
                        {{
                          professionalClassCouncilValue({
                            id: group_prescription_care.care_check.checked_user
                              .professional_class_council_id,
                            name: group_prescription_care.care_check
                              .checked_user.user_name,
                            cpf: group_prescription_care.care_check.checked_user
                              .user_cpf,
                            office:
                              group_prescription_care.care_check.checked_user
                                .user_office,
                            value:
                              group_prescription_care.care_check.checked_user
                                .professional_class_council_value,
                          })
                        }}
                      </h6>
                    </div>

                    <div
                      v-if="
                        group_prescription_care.prescription_care.frequency ==
                        'EVENTUAL'
                      "
                    >
                      <div
                        v-for="item of group_prescription_care.prescription_care
                          .quantity_of_times_checked"
                        :key="item.id"
                      >
                        <div v-if="item.photo">
                          <img :src="item.photo" width="300px" height="300px" />
                        </div>
                        <h6
                          class="legends worksansr"
                          v-if="item.status == 'CHECADO'"
                        >
                          <strong class="upper-text">Checado por:</strong>
                          {{
                            professionalClassCouncilValue({
                              id: item.checked_user
                                .professional_class_council_id,
                              name: item.checked_user.user_name,
                              cpf: item.checked_user.user_cpf,
                              office: item.checked_user.user_office,
                              value:
                                item.checked_user
                                  .professional_class_council_value,
                            })
                          }}
                          às {{ String(item.checked_time).substr(0, 5) }}
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center justify-content-center pt-0 pb-0"
                  >
                    <StatusCare
                      :prescription_care_time="
                        group_prescription_care.prescription_care_time
                      "
                      :care_check="group_prescription_care.care_check"
                      :eventual="check.time"
                      :date="date"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                  >
                    <ActionCare
                      v-on:success="handleSuccess"
                      v-on:checked="$emit('checked')"
                      :resident_id="resident_id"
                      :date="date"
                      :group_prescription_care="group_prescription_care"
                    />
                  </div>

                  <div
                    class="col-md-12 pt-0 pb-0"
                    v-if="group_prescription_care.care_check.data_base64"
                  >
                    <ButtonGenerateCertificate
                      :modal_id="group_prescription_care.care_check.data_base64"
                      :id="group_prescription_care.id"
                      :data_base64="
                        group_prescription_care.care_check.data_base64
                      "
                    />
                  </div>

                  <div class="col-md-12 pt-0 pb-0">
                    <LinkVerLocalizacaoRegistro
                      :item="group_prescription_care.care_check"
                    />
                  </div>
                </div>
                <hr class="m-0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../templates/Components/ErrorsMessages";

import ButtonGenerateCertificate from "../../../../templates/Components/ButtonGenerateCertificate";

import LinkVerLocalizacaoRegistro from "../../../../templates/Components/LinkVerLocalizacaoRegistro";

import StatusCare from "../../../../templates/Prescription/CheckCare/Status";

import DataCare from "../../../../templates/Prescription/CheckCare/Care";

import ActionCare from "../../../../templates/Prescription/CheckCare/Action";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { userData, getStatic } from "../../../../lib/functions";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import moment from "moment";

export default {
  name: "Checks",
  components: {
    ErrorsMessages,
    StatusCare,
    DataCare,
    ActionCare,
    ButtonGenerateCertificate,
    LinkVerLocalizacaoRegistro,
  },
  data() {
    return {
      accessed_offline: false,
      rest_home_id: "",
      resident_id: "",
      date: moment().format("YYYY-MM-DD"),
      dateLabel: moment().format("YYYY-MM-DD"),
      time: "",
      status: "TODOS",
      start_date: "",
      end_date: "",
      checks: [],
      cares_check: [],
      advanceDates: [],
      errors: [],
      loading: false,
      action_cares_check: true,
      exist: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    professionalClassCouncilValue,
    handleCheckboxAll(event, time) {
      this.time = "";

      let { checks } = this;

      let checkboxs = document.querySelectorAll(".check-input-care");
      let checkboxsAll = document.querySelectorAll(".check-input-care-all");

      let cares_check = [];
      let cares_id = [];

      if (event.target.checked) {
        for (let checkboxAll of checkboxsAll) {
          if (checkboxAll.dataset.time == time) {
            checkboxAll.checked = true;
          } else {
            checkboxAll.checked = false;
          }
        }

        for (let checkbox of checkboxs) {
          if (checkbox.dataset.time == time) {
            cares_id.push(checkbox.id);
            checkbox.checked = true;
          } else {
            checkbox.checked = false;
          }
        }

        for (let care_id of cares_id) {
          for (let check of checks) {
            for (let item of check.items) {
              if (
                `care-${item.group_prescription_care.prescription_care_time.id}` ==
                care_id
              ) {
                let { prescription_care, prescription_care_time, care_check } =
                  item.group_prescription_care;

                cares_check.push({
                  prescription_care_time_id: prescription_care_time.id,
                  prescription_care_time: prescription_care_time,
                  care_check: care_check,
                  prescription_care: {
                    care_id: prescription_care.care_id,
                    care_type: prescription_care.care_type,
                    unit_of_measurement_id:
                      prescription_care.unit_of_measurement_id,
                    active_ingredient_id:
                      prescription_care.active_ingredient_id,
                  },
                });
              }
            }
          }
        }

        this.time = time;
        this.cares_check = cares_check;
      } else {
        for (let checkboxAll of checkboxsAll) {
          if (checkboxAll.dataset.time == time) {
            checkboxAll.checked = false;
          } else {
            checkboxAll.checked = false;
          }
        }

        for (let checkbox of checkboxs) {
          if (checkbox.dataset.time == time) {
            checkbox.checked = false;
          } else {
            checkbox.checked = false;
          }
        }

        this.time = "";
        this.cares_check = [];
      }
    },
    handleTextStatus(status) {
      if (status == "ATRASADO") {
        return "ATRASADOS";
      } else if (status == "CHECADO") {
        return "CHECADOS";
      } else if (status == "PENDENTE") {
        return "PENDENTES";
      } else {
        return "TODOS";
      }
    },
    handleRemoveSeparateWarning(cares) {
      let ids = cares.map(
        ({ prescription_care_time_id }) => `care-${prescription_care_time_id}`
      );

      let checkboxs = document.querySelectorAll(".check-input-care");

      for (let checkbox of checkboxs) {
        if (ids.includes(checkbox.id)) {
          checkbox.checked = false;
        }
      }

      let cares_check = [];

      for (let item of this.cares_check) {
        if (!ids.includes(`care-${item.prescription_care_time.id}`)) {
          cares_check.push(item);
        }
      }

      this.cares_check = cares_check;
    },
    handleSuccess() {
      let checkboxs = document.querySelectorAll(".check-input-care");
      let checkboxsAll = document.querySelectorAll(".check-input-care-all");
      for (let checkboxAll of checkboxsAll) {
        checkboxAll.checked = false;
      }
      for (let checkbox of checkboxs) {
        checkbox.checked = false;
      }

      this.time = "";
      this.cares_check = [];

      this.paginate();
    },
    handleCheckbox(time) {
      this.time = "";
      // this.action_cares_check = false;

      let checkboxs = document.querySelectorAll(".check-input-care");

      let cares_check = [];
      let cares_id = [];

      for (let checkbox of checkboxs) {
        if (checkbox.dataset.time == time) {
          if (checkbox.checked) {
            cares_id.push(checkbox.id);
          }
        } else {
          checkbox.checked = false;
        }
      }

      let { checks } = this;

      for (let care_id of cares_id) {
        for (let check of checks) {
          for (let item of check.items) {
            if (
              `care-${item.group_prescription_care.prescription_care_time.id}` ==
              care_id
            ) {
              let { prescription_care, prescription_care_time, care_check } =
                item.group_prescription_care;

              cares_check.push({
                prescription_care_time_id: prescription_care_time.id,
                prescription_care_time: prescription_care_time,
                care_check: care_check,
                prescription_care: {
                  care_id: prescription_care.care_id,
                  care_type: prescription_care.care_type,
                  unit_of_measurement_id:
                    prescription_care.unit_of_measurement_id,
                  active_ingredient_id: prescription_care.active_ingredient_id,
                },
              });
            }
          }
        }
      }

      this.time = time;
      this.cares_check = cares_check;
      // setTimeout(() => (this.action_cares_check = true), 1);
    },
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { date } = routes.history.current.query;

      if (date) {
        this.date = date;
        this.dateLabel = date;
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        this.loading = false;
        let residents;
        try {
          residents = (await getStatic("/offline/residents/checks", true))
            .residents;
        } catch (errors) {
          this.errors = errors;
          return;
        }

        let resident = residents.find((item) => item.id == id);

        if (resident) {
          let advanceDates = [];
          for (let check of resident.checks) {
            advanceDates.push(check.date);
          }

          this.advanceDates = advanceDates;

          let { checks } = resident;

          if (checks[0] && checks[0].groupTimes) {
            let exist = false;
            for (let check of checks[0].groupTimes) {
              if (check.items.length > 0) {
                exist = true;
              }
            }

            this.exist = exist;
            this.checks = checks[0].groupTimes;
            this.dateLabel = checks[0].date;
          }
        }
      } else {
        await this.paginate();
      }
    },
    async paginate() {
      try {
        this.loading = true;
        this.errors = [];

        const {
          rest_home_id,
          resident_id,
          date,
          start_date,
          end_date,
          status,
        } = this;

        let params = {
          rest_home_id,
          resident_id,
          date,
          start_date,
          end_date,
          status,
        };

        const response = await api.get("/rest-home/resident/checks-care", {
          params,
        });

        const { error, errors, checks } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let exist = false;
          for (let check of checks) {
            if (check.items.length > 0) {
              exist = true;
            }
          }

          this.exist = exist;
          this.checks = checks;
          this.dateLabel = date;
          this.$bvModal.hide("filterNormal");
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },
    async handleFilter() {
      let { accessed_offline, resident_id, date } = this;
      if (accessed_offline) {
        this.checks = [];
        let residents = (await getStatic("/offline/residents/checks", true))
          .residents;

        let resident = residents.filter((item) => item.id == resident_id);

        if (resident[0]) {
          let { checks } = resident[0];

          let items = checks.filter((item) => item.date == date);

          if (items[0]) {
            let cares = items[0].groupTimes;
            let exist = false;

            for (let check of cares) {
              if (check.items.length > 0) {
                exist = true;
              }
            }
            this.exist = exist;
            this.checks = cares;
            this.dateLabel = date;
          }
        }

        this.$bvModal.hide("filterNormal");
      } else {
        this.paginate();
      }
    },
  },
};
</script>

<style>
.checks li {
  list-style-type: none;
}

.checks .checks-care-times-actions {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

.checks .checks-care-times {
  border: 2px #d3d3d3;
  border-style: dashed;
  border-radius: 12px;
  padding: 5px;
}

.checks .checks-care-times-header {
  background-color: #f5f5f5;
  font-weight: 700;
}

.checks .checks-care-times-header h6 {
  font-size: 25px;
  font-weight: 700;
}

.checks .checks-care-time-on-box {
  border: 2px #6b976b;
  border-style: dashed;
  border-radius: 12px;
  background-color: #f3f8f3;
}

.checks .checks-care-time-on-box .checks-care-time-on-box-message {
  margin: 0;
  padding: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #6b976b;
}

.checks .checks-care-time-on-box .checks-care-time-on-box-message p {
  text-align: center;
  margin: 0;
  font-weight: 700;
  color: #fff;
}

.checks .checks-care-time-alert {
  background-color: #f8f2a0;
  padding: 10px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
}
</style>
